










































import { getCurrentInstance, ComponentInternalInstance, defineComponent, computed } from '@vue/composition-api';
export default defineComponent({
  name: 'EmptyDetail',
  props: {},
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const fileTotal = computed(() => vm.$store.state.drawer.total);
    const routeName = computed(() => vm.$route.name);
    return {
      fileTotal,
      routeName,
    };
  },
});
